var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxTrashAltSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.33203H6C5.26467 1.33203 4.66667 1.93003 4.66667 2.66536V3.9987H2V5.33203H3.33333V13.332C3.33333 14.0674 3.93133 14.6654 4.66667 14.6654H11.3333C12.0687 14.6654 12.6667 14.0674 12.6667 13.332V5.33203H14V3.9987H11.3333V2.66536C11.3333 1.93003 10.7353 1.33203 10 1.33203ZM6 2.66536H10V3.9987H6V2.66536ZM11.3333 13.332H4.66667V5.33203H11.3333V13.332Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTrashAltSmall);
export default __webpack_public_path__ + "static/media/bx-trash-alt-small.7722d00461023412dfdf633ce7ea452e.svg";
export { ForwardRef as ReactComponent };